// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab-menu":"TabMenu_pintxo-tab-menu__9qDBl","pintxo-tab-menu__container":"TabMenu_pintxo-tab-menu__container__PbRYf"};